
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class ApprovalInLaborGrid extends Serenity.EntityGrid<ApprovalInLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInLabor'; }
        protected getIdProperty() { return ApprovalInLaborRow.idProperty; }
        protected getInsertPermission() { return ApprovalInLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInLaborRow.localTextPrefix; }
        protected getService() { return ApprovalInLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}